






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { pageClickedBeacon } from '@utils/analytics';
import { Toast } from 'types/layout';

@Component
export default class ToastMessage extends Vue {
	@Prop()
	toast!: Toast;

	active = false;

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	dismissalTimer: any;

	dismissAnimationTime = 500;

	dismissed = false;

	initialTimeActive = 3000;

	get messageContainsLink(): boolean {
		return this.toast.message.indexOf('</a>') >= 0;
	}

	created(): void {
		setTimeout(() => {
			this.active = true;
			this.setDismissalTimer(this.initialTimeActive);
		}, 30);
	}

	clearDismissalTimer(): void {
		clearTimeout(this.dismissalTimer);
	}

	dismissToast(): void {
		this.clearDismissalTimer();

		this.dismissed = true;
		setTimeout(() => {
			this.remove();
		}, this.dismissAnimationTime);
	}

	remove(): void {
		this.$emit('dismiss', this.toast);
	}

	setDismissalTimer(timeToSet: number): void {
		if (!this.messageContainsLink) {
			this.dismissalTimer = setTimeout(() => {
				this.dismissToast();
			}, timeToSet);
		}
	}

	trackClick(): void {
		pageClickedBeacon({ slot: [this.$vnode], clickText: this.toast.message });
	}
}
